import { useTranslation } from 'next-i18next'
import React, { useEffect } from 'react'
import { Head, VerifyIdentity } from '../../../src/component'
import { VERIFY_PREFETCH_ROUTE_COUNTRY_MAP, usePostLoginRoute } from '../../../src/config/router'
import { TrackPageViewed } from '../../../src/integrations/monitoring'
import { CheckoutPage, CheckoutStatus, isCountryNeedsBiometricVerification } from '../../../src/model'
import { useAppRouter, useCheckoutState, useCountry } from '../../../src/state'
import { Country } from '@afterpay/types'
import { IdentityVerificationNationalNumber } from '../../../src/component/IdentityVerificationNationalNumber'

export const VerifyIdentityPage: CheckoutPage = () => {
  const { t } = useTranslation()
  const router = useAppRouter()
  const country = useCountry()
  const { status } = useCheckoutState()
  const postLoginRoute = usePostLoginRoute()
  const needsBiometricVerification = isCountryNeedsBiometricVerification(country)

  useEffect(() => {
    if (status !== CheckoutStatus.IdentityIneligible && !needsBiometricVerification) {
      router.push(postLoginRoute)
    }

    VERIFY_PREFETCH_ROUTE_COUNTRY_MAP[country]?.forEach((route) => {
      router.prefetch(route)
    })
  }, [country])

  const handleDocumentTypeSelection = async (route): Promise<void> => {
    router.push(route)
  }

  const verifyComponentCountryMap = {
    [Country.US]: <IdentityVerificationNationalNumber />,
    [Country.AU]: <VerifyIdentity onSelect={handleDocumentTypeSelection} />,
    [Country.NZ]: <VerifyIdentity onSelect={handleDocumentTypeSelection} />,
    [Country.GB]: <VerifyIdentity onSelect={handleDocumentTypeSelection} showProfile showHelpFooter={false} />,
  }

  return (
    <>
      <Head title={t('verifyIdentity:pageTitle')} />
      {verifyComponentCountryMap[country]}
      <TrackPageViewed />
    </>
  )
}
